import { momentModule } from '../vendor/moment';

export const timeRemainingFilterModule = angular
  .module('Q.filters.time-remaining', [momentModule])
  .filter('timeRemaining', function (moment) {
    return function timeAgo(value, format) {
      if (typeof value === 'undefined' || value === null) {
        return '';
      }

      const d = moment.duration(value, format);
      const mins = d.minutes();
      const hours = Math.floor(d.asMinutes() - mins) / 60;

      const pluralize = (s, count) => {
        return count === 1 ? s : s + 's';
      };

      if (hours > 0) {
        return `${hours} ${pluralize('hour', mins)}, ${mins} ${pluralize('minute', mins)}`;
      } else if (mins > 0) {
        return `${mins} ${pluralize('minute', mins)}`;
      } else {
        return `less than a minute`;
      }
    };
  });
